import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { AdminTableAction } from "stores/AdminVendorStore/AdminTableAction";
import { VendorDetailActions } from "stores/VendorDetailsStore/VendorDetailAction";

const mapStateToProps = (state) => {
  return {
    VendorDetailList:state.Vendordetail.VendorDetailList,
    AdminTableList: state.AdminTable.AdminTableList,
  };
};

const mapDispatchToProps = (dispatch) => bindActionCreators({
  getVendorDetailsAction:VendorDetailActions.getVendorDetail,
  getAdminTableAction: AdminTableAction.getAdminTable,

}, dispatch);

const VendorDetailsStore = (Container) =>
  connect(mapStateToProps, mapDispatchToProps)(Container);
export default VendorDetailsStore;
